<script context="module" lang="ts">
  import * as _ from "lodash";
  import { containerSort } from "@shared/services/product.js";

  import type { Product } from "@shared/types/ProductLine";
  import type { DiscountResult } from "@retailer/services/discounts_service";

  export const prepareContainers = function (
    products: Product[],
    productsForDisplay: Product[],
    discounts: DiscountResult[],
    usesFuturePricingWithMinBottle: boolean,
    preSelectedContainerType: string,
  ) {
    let productsByContainer = { recentlyOrdered: [], deals: [] };
    let containerTypes = [];
    let hasDiscount = false;

    const inventoryIdsWithDiscounts = discounts.reduce((hash, discount) => {
      if (discount.inventory_id) {
        hash[discount.inventory_id] = true;
      }
      return hash;
    }, {});

    if (!(products[0] || {}).inventory_id) {
      return;
    }

    var containerTypesOrder = ["bottle", "can", "keg", "box", "package", "item", "other"];

    productsForDisplay.forEach(product => {
      // Sort the objects by container
      var container = product.container_type;
      if (!productsByContainer.hasOwnProperty(container)) {
        productsByContainer[container] = [];
        containerTypes.push(container);
      }
      // manually add recently ordered
      if (product.recently_ordered) {
        productsByContainer.recentlyOrdered.push(product);
      }

      if (!usesFuturePricingWithMinBottle && inventoryIdsWithDiscounts[product.inventory_id]) {
        productsByContainer.deals.push(product);
        hasDiscount = true;
      }

      productsByContainer[container].push(product);
    });

    containerTypes.sort(function (a, b) {
      return containerTypesOrder.indexOf(a) - containerTypesOrder.indexOf(b);
    });
    productsByContainer = containerSort(productsByContainer);

    let selectedContainerType = containerTypes[0];

    const showDeals = productsByContainer.deals.length > 0 && !usesFuturePricingWithMinBottle;
    const showRecentlyOrdered = productsByContainer.recentlyOrdered.length > 0;
    if (preSelectedContainerType && containerTypes.includes(preSelectedContainerType)) {
      selectedContainerType = preSelectedContainerType;
    } else {
      if (showRecentlyOrdered) {
        selectedContainerType = "recentlyOrdered";
      }
      if (!usesFuturePricingWithMinBottle && hasDiscount) {
        selectedContainerType = "deals";
      }
    }

    return {
      productsByContainer,
      selectedContainerType,
      showDeals,
      showRecentlyOrdered,
      hasDiscount,
      containerTypes,
    };
  };

  export const widgetItemIsOrderable = (user, widgetItem) => {
    return !user.limited_ordering || user.group_director || widgetItem?.buying_options.length > 0;
  };

  export const widgetItemIsRequestable = (user, widgetItem) => {
    return widgetItem?.mandate_list?.additional_action === "mandate_list.request_item";
  };
  export const widgetItemHasBeenRequested = (user, widgetItem) => {
    return (
      user.limited_ordering && widgetItem?.mandate_list?.additional_action?.endsWith("_request")
    );
  };
</script>
